import { Box } from 'native-base';
import React from 'react';
import { useHomeFeedItems, useSurveyFeedItems } from '../../hooks';
import { SurveyCard } from '../ui';
import { NoData } from '../NoData';
import { FeedItemList } from './FeedItemsList';

export interface HomeFeedItemsListProps {}

export const HomeFeedItemsList: React.FC<HomeFeedItemsListProps> = () => {
  const { homeFeedItems } = useHomeFeedItems();
  const { surveyFeedItems, completeSurvey } = useSurveyFeedItems();

  const hasContent = homeFeedItems.length > 0 || surveyFeedItems.length > 0;

  if (!hasContent) {
    return <NoData py={4} message="No feed data available." />;
  }

  return (
    <Box>
      {surveyFeedItems.map((survey) => (
        <SurveyCard
          key={survey.id}
          id={survey.id}
          title={survey.title}
          description={survey.description}
          actionLink={survey.actionLink}
          actionText={survey.actionText}
          onComplete={completeSurvey}
        />
      ))}
      <FeedItemList feedItems={homeFeedItems} />
    </Box>
  );
};
